import ApplicationController from './application_controller.js'
import { fetchAndRenderChart } from '../packs/application/distributors/users/cashflow-charts'
import toastr from 'toastr'
/* This is the custom StimulusReflex controller for the Cashflow Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  static targets = ["select", "sendButton", "capitalTarget"];

  connect () {

    super.connect()
    let id      = this.element.dataset['id']
    let locale  = this.element.dataset['locale']

    console.log("CASHFLOW Stimulus Connect! ID", id)
    console.log("CASHFLOW Stimulus Connect! LOCALE", locale)

    //$('select').select2()

    // Capture the select2 event and send it as a standard change event so that reflex controller can handle it
    $(this.selectTarget).on('select2:select', function () {
      let event = new Event('change', { bubbles: true })
      this.dispatchEvent(event);
    })
  }

  async exportXlsx(event) {
    event.preventDefault();

    const url = event.currentTarget.dataset.cashflowExportUrl;

    const profileId = this.selectTarget.value;
    if (!profileId) {
      toastr.error("Veuillez sélectionner un profil d'investisseur", "", {
        closeButton: true,
        progressBar: true,
        positionClass: "toast-top-right",
        timeOut: 5000
      })
      return
    }

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content
        }
      });

      if (!response.ok) {
        let errorMsg = `Erreur HTTP ${response.status}`;
        try {
          const errorBody = await response.text();
          if (errorBody) errorMsg = errorBody;
        } catch (e) {
          console.warn("Impossible de parser l'erreur", e);
        }
        throw new Error(errorMsg);
      }

      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = this.filenameFromResponse(response);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Erreur lors de l'export XLSX:", error);
      toastr.error(`${error.message}`, "", {
        closeButton: true,
        progressBar: true,
        positionClass: "toast-top-right",
        timeOut: 8000
      });
    }
  }

  // Nom du fichier renvoyé par le serveur (Content-Disposition), avec le nom du client
  filenameFromResponse(response) {
    const disposition = response.headers.get('Content-Disposition') || "";

    const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (encoded) return decodeURIComponent(encoded[1]);

    const plain = disposition.match(/filename="?([^";]+)"?/i);
    return plain ? plain[1] : "flux_cash_previsionnels.xlsx";
  }

  // Nouvelle méthode pour l'envoi du cashflow par mail
  async sendCashflow(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const profileId = this.selectTarget.value;
    if (!profileId) {
      toastr.error("Veuillez sélectionner un profil d'investisseur", "", {
        closeButton: true,
        progressBar: true,
        positionClass: "toast-top-right",
        timeOut: 5000
      })
      return
    }

    // Récupération du chart affiché
    const chartDom = document.getElementById("cf_echarts");
    if (!chartDom) {
      toastr.error("Graphique introuvable", "", {
        closeButton: true,
        progressBar: true,
        positionClass: "toast-top-right",
        timeOut: 5000
      });
      return;
    }

    const chart = echarts.getInstanceByDom(chartDom);
    if (!chart) {
      toastr.error("Instance ECharts introuvable", "", {
        closeButton: true,
        progressBar: true,
        positionClass: "toast-top-right",
        timeOut: 5000
      });
      return;
    }

    // Conversion du graphique en base64
    const imageBase64 = chart.getDataURL({
      type: "png",
      backgroundColor: "#FFFFFF",
      pixelRatio: 2
    });

    // Sauvegarder l'état original du bouton
    const originalHtml = this.sendButtonTarget.innerHTML;
    this.sendButtonTarget.innerHTML = `
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Envoi en cours...
    `;
    this.sendButtonTarget.disabled = true;

    try {
      const response = await fetch(this.data.get("sendUrl"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content
        },
        body: JSON.stringify({
          profile_id: profileId,
          chart_image: imageBase64
        })
      });

      const data = await response.json();

      if (response.ok) {
        toastr.success("Email envoyé avec succès!", "", {
          closeButton: true,
          progressBar: true,
          positionClass: "toast-top-right",
          timeOut: 5000
        });
      } else {
        throw new Error(data.error || "Erreur lors de l'envoi");
      }
    } catch (error) {
      console.error("Erreur:", error);
      toastr.error(`${error.message}`, "", {
        closeButton: true,
        progressBar: true,
        positionClass: "toast-top-right",
        timeOut: 8000
      });
    } finally {
      // Restaurer le bouton à son état original
      this.sendButtonTarget.innerHTML = originalHtml;
      this.sendButtonTarget.disabled = false;
    }
  }


  profile(event) {
    console.log("CASHFLOW CHANGE EVENT:", event.target)
    console.log("CASHFLOW CHANGE EVENT:", this.selectTarget.value)

    let profile_id = this.selectTarget.value

    // Masquer la section si aucun profil sélectionné
    const chartSection = document.getElementById('cashflow-chart-section');
    if (!profile_id) {
      if (chartSection) chartSection.style.display = 'none';
      return;
    }

    const locale = document.documentElement.lang || this.element.dataset.locale || 'fr';
    this.selectTarget.dataset.locale = locale;

    if (this.isActionCableConnectionOpen() ) {

      console.log('launch Stimulate')

      this.stimulate('Cashflow#profile', profile_id).then( () => {
        console.log('The Reflex has benne finalized.')
      }).catch( () => {
        console.log('CATCH ERROR!!!')
      })

    } else {
      setTimeout(function () {
      }.bind(this), 200);
    }

    
    // console.log('Nominative from Stimulus', this.element.dataset['nominative'])
    // console.log('SubID from Stimulus', this.element.dataset['subid'])

    // console.log('isActionCableConnectionOpen', this.isActionCableConnectionOpen())

    // if (this.isActionCableConnectionOpen() ) {

    //   this.stimulate('Subscription#nominative', event.target).then( () => {
    //     console.log('The Reflex has benne finalized.')
    //     $('select').select2()
    //   }).catch( () => {
    //     console.log('CATCH ERROR!!!')
    //   })

    // } else {
    //   setTimeout(function () {
    //     this.nominative(event)
    //   }.bind(this), 200);
    // }

  }

  addfundsimulate(event) {

    event.preventDefault()
    event.stopImmediatePropagation()

    console.log("CASHFLOW SUBMIT FORM EVENT:", event.target)
    console.log("CASHFLOW SUBMIT TARGET VALUE", this.selectTarget.value)
 
    if (this.isActionCableConnectionOpen() ) {

      const form = event.target
      const formData = new FormData(form)
      const params = {}

      for (const [key, value] of formData.entries()) {
        params[key] = value
      }

      // injecte dans attribut HTML si tu veux garder la logique existante :
      // form.setAttribute("data-form-params", JSON.stringify(params))

      this.stimulate('Cashflow#addfundsimulate', params).then( () => {
        console.log('The Reflex has benne finalized.')
      }).catch( () => {
        console.log('CATCH ERROR!!!')
      })

    } else {
      setTimeout(function () {
      }.bind(this), 200);
    }

  }

  // Mise à jour du capital target
  updateCapitalTarget(event) {
    const capitalValue = parseInt(this.capitalTargetTarget.value) || 0;
    console.log("Capital Target:", capitalValue);

    // Mettre à jour le graphique avec la nouvelle valeur
    this.refreshChartWithCapitalTarget(capitalValue);
  }

  // Rafraîchir le graphique avec le capital target
  refreshChartWithCapitalTarget(capitalValue) {
    const footer = document.getElementById('cf_tfoot');
    if (!footer) return;

    const footerRow = footer.querySelector('tr');
    if (!footerRow) return;

    const dataSet = footerRow.dataset?.totals ? JSON.parse(footerRow.dataset.totals) : [];
    const yearlyDetails = footerRow.dataset?.yearlyDetails ? JSON.parse(footerRow.dataset.yearlyDetails) : {};

    fetchAndRenderChart(dataSet, capitalValue, yearlyDetails);
  }

  afterCreate(element, reflex) {
    console.log("\n\nFINALIZE_CREATE:\n\n", element, reflex)
    // let id = element.dataset.id
    // let locale = element.dataset.locale
    // console.log("LOCALE", locale)
    // document.location.href = "/user/subscriptions/"+id+"/edit?locale="+locale+"&step=2"
  }

  // finalizeCreate(element, reflex, noop, reflexId) {
  //   console.log("FINALIZED")
  // }


  afterReflex(element, reflex, error) {
    console.log("afterREFLEX !!! insert code here !!!", reflex)

    const footer   = document.getElementById('cf_tfoot').querySelector('tr');
    const dataSet  = footer.dataset?.totals ? JSON.parse(footer.dataset.totals) : [];
    const yearlyDetails = footer.dataset?.yearlyDetails ? JSON.parse(footer.dataset.yearlyDetails) : {};
    const REFLEXES = ['Cashflow#profile', 'Cashflow#removefund', 'Cashflow#addfundsimulate'];

    if ( REFLEXES.includes(reflex) ) {
      console.log('LANCE ECHARTS SCRIPT')

      const capitalValue = this.hasCapitalTargetTarget ?
            this.getNumericValue(this.capitalTargetTarget.value) : 0;

      const chartSection = document.getElementById('cashflow-chart-section');
      if (chartSection) {
        if (dataSet.length > 0) {
          console.log('Affichage de la section graphique');
          chartSection.style.display = 'block';
        } else {
          console.log('Masquage de la section graphique - pas de données');
          chartSection.style.display = 'none';
        }
      }

      fetchAndRenderChart(dataSet, capitalValue, yearlyDetails);
    }

    // Initialisation des tooltips Bootstrap après chaque mise à jour du tableau
    if (typeof $ !== 'undefined' && $.fn.tooltip) {
      $('[data-toggle="tooltip"]').tooltip();
    }

    if ($("#fund_id")) $("#fund_id").select2(); // Transform the fund select element to a select2 element

  }

  formatCapitalInput(event) {
    const input = event.target;
    const cursorPosition = input.selectionStart;
    const oldValue = input.value;
    const oldLength = oldValue.length;

    const numericValue = oldValue.replace(/\s/g, '');

    if (!/^\d*$/.test(numericValue)) {
      const validValue = numericValue.replace(/\D/g, '');
      input.value = this.formatNumber(validValue);
      return;
    }

    // Formater avec des espaces
    const formattedValue = this.formatNumber(numericValue);
    input.value = formattedValue;

    // Ajuster la position du curseur
    const newLength = formattedValue.length;
    const spacesAdded = (newLength - oldLength);
    const newCursorPosition = cursorPosition + spacesAdded;

    // Repositionner le curseur
    setTimeout(() => {
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);
  }

  formatNumber(value) {
    if (!value) return '';
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  getNumericValue(formattedValue) {
    return parseInt(formattedValue.replace(/\s/g, '')) || 0;
  }

  // Mise à jour du capital target
  updateCapitalTarget(event) {
    const formattedValue = this.capitalTargetTarget.value;
    const capitalValue = this.getNumericValue(formattedValue);
    console.log("Capital Target:", capitalValue);

    // Mettre à jour le graphique avec la nouvelle valeur
    this.refreshChartWithCapitalTarget(capitalValue);
  }

  // Rafraîchir le graphique avec le capital target
  refreshChartWithCapitalTarget(capitalValue) {
    const footer = document.getElementById('cf_tfoot');
    if (!footer) return;

    const footerRow = footer.querySelector('tr');
    if (!footerRow) return;

    const dataSet = footerRow.dataset?.totals ? JSON.parse(footerRow.dataset.totals) : [];
    const yearlyDetails = footerRow.dataset?.yearlyDetails ? JSON.parse(footerRow.dataset.yearlyDetails) : {};

    fetchAndRenderChart(dataSet, capitalValue, yearlyDetails);
  }

  fetchChart (reflex) {
    const footer   = document.getElementById('cf_tfoot').querySelector('tr');
    const dataSet  = footer.dataset?.totals ? JSON.parse(footer.dataset.totals) : [];
    const REFLEXES = ['Cashflow#profile', 'Cashflow#removefund', 'Cashflow#addfundsimulate'];
    console.log('REFLEXES', REFLEXES)

    if ( REFLEXES.includes(reflex) ) {
      console.log('LAUCNE ECHATS SCRIPT')

      const capitalValue = this.hasCapitalTargetTarget ?
            (parseInt(this.capitalTargetTarget.value) || 0) : 0;

      fetchAndRenderChart(dataSet, capitalValue);
    }
  }
  ////  add DATA with MORPH in data-totals tag and recover if with  JSON.parse( $('#json_data'))?;dataset?totals || '[]' )
 ///// execute script for echarts with JSON DATA

  finalizeReflex(anchorElement) {
    console.log("FinalizeREFELX")
  }

}
